import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { GetTotalInput, SavedSurveyInfo, SaveItem, SearchType } from 'models';
import { DirectSearchService, SurveyService } from 'src/_services';
import { BtnComponent } from 'src/app/components/utilities/btn/btn.component';
import { TotalsUtility } from 'utility';

@Component({
  selector: 'app-save-survey-modal',
  templateUrl: './save-survey-modal.component.html',
  styleUrl: './save-survey-modal.component.css',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    BtnComponent
  ]
})
export class SaveSurveyModalComponent implements OnInit {

  surveySave: SaveItem = undefined;
  surveySaveInfo: SavedSurveyInfo = undefined;
  saveName: string = undefined;
  isOverride: boolean = true;
  isOverrideCBHidden: Boolean = true;
  searchType: SearchType;

  constructor(
    private dialogRef: MatDialogRef<SaveSurveyModalComponent>,
    @Inject(MAT_DIALOG_DATA) private data: SearchType,
    private survey: SurveyService,
    private directSearch: DirectSearchService,
    private router: Router
  ) {
    this.searchType = data;
  }

  ngOnInit(): void {
    const url = this.router.url;
    this.surveySaveInfo = url.toLocaleLowerCase().startsWith('/survey') ? this.survey.getSavedSurveyInfo() : undefined;
    if (this.surveySaveInfo) {
      this.saveName = this.surveySaveInfo.name;
      this.isOverride = true;
      this.isOverrideCBHidden = false;
    }
    else {
      this.isOverride = false;
      this.isOverrideCBHidden =true;
    }
  }

  save() {
    this.surveySave = {
      Id: !this.isOverride || !this.surveySaveInfo ? 0 : parseInt(this.surveySaveInfo.id),
      Name: this.saveName,
      Search: this.searchType == 'survey' ? TotalsUtility.getTotalInput(this.survey.getQuestions()) : null,
      SearchProduct: this.searchType == 'directSearch' ? this.directSearch.getDirectSearchInput() : null
    }

    this.survey.saveSurvey(this.surveySave, this.saveSuccess.bind(this), this.saveError.bind(this));
  }

  saveSuccess() {
    this.survey.updateSavedSurvey(this.surveySave);
    this.closeDialog('success');
  }

  saveError() {
    this.closeDialog('error');
  }

  closeDialog(data: ('success' | 'error' | 'canceled') = 'canceled') {
    this.dialogRef.close(data);
  }

}
